import { useFeeCalculatorSectionErrorStates } from "@hooks/useFeeCalculatorSectionErrorStates";
import { FeeCalculatorValidStateConditions } from "@models/platform-analysis/entities/steps/fee";
import { FeeCalculatorSectionId } from "@models/platform-analysis/enums/fee/feeCalculatorSectionId";
import { updateFeeCalculatorSectionErrorState } from "@redux/slices/platform-analysis";
import { useAppDispatch } from "@redux/store";
import { isEqual } from "lodash";
import { memo, useRef } from "react";

type Props = {
  sectionId: FeeCalculatorSectionId;
  validateStateConditions?: FeeCalculatorValidStateConditions[];
  isPortfolioSetupSection: boolean;
  onErrorStatesChange?: (errorStates: string[]) => void;
};

export const FeeCalculatorErrorStatesTracker = memo(
  ({
    sectionId,
    validateStateConditions,
    isPortfolioSetupSection = false,
    onErrorStatesChange,
  }: Props) => {
    const dispatch = useAppDispatch();
    const prevValueRef = useRef<string[]>();

    const { errorStates } = useFeeCalculatorSectionErrorStates({
      conditionConfigs: validateStateConditions,
      isPortfolioSetupSection,
    });

    if (!isEqual(prevValueRef.current, errorStates)) {
      prevValueRef.current = errorStates;
      dispatch(
        updateFeeCalculatorSectionErrorState({
          key: sectionId,
          hasError: errorStates.length > 0,
        }),
      );
      onErrorStatesChange?.(errorStates);
    }

    return <></>;
  },
);
